module.exports = __webpack_public_path__ + "images/social-icons/f_logo_RGB-White_250-9eb762c6e6fc750beb66bc3ca2d64c82.png";